import { useState, useRef, useEffect } from 'react';

import CopyToClipboard from '@mindtickle/copy-to-clipboard';

const useCopyData = (copyText: string) => {
  const copyRef = useRef(0);
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const onCopyHandler = () => {
    CopyToClipboard.copy({ textToCopy: copyText, onCopy });
  };

  useEffect(() => () => clearTimeout(copyRef.current), []);

  return { isCopied, onCopyHandler };
};

export default useCopyData;
